var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 8,
    viewBox: "0 0 16 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3536 4.49271C15.5488 4.29745 15.5488 3.98087 15.3536 3.78561L12.1716 0.603626C11.9763 0.408364 11.6597 0.408364 11.4645 0.603626C11.2692 0.798888 11.2692 1.11547 11.4645 1.31073L14.2929 4.13916L11.4645 6.96759C11.2692 7.16285 11.2692 7.47943 11.4645 7.67469C11.6597 7.86996 11.9763 7.86996 12.1716 7.67469L15.3536 4.49271ZM0 4.63916H15V3.63916H0V4.63916Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDark);
export default __webpack_public_path__ + "static/media/arrow-dark.f80adb1935b23deda3391d6d209db0b7.svg";
export { ForwardRef as ReactComponent };